var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('panelify',{attrs:{"extName":"Lunch Mama","appName":"AEFT","src":"https://hardcore-easley-0fd66d.netlify.com/#/","width":"440px","height":"600px","gradient":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }